// extracted by mini-css-extract-plugin
export var compactFilters = "_im-4";
export var detailImage = "_im-1";
export var dropdownContainer = "_im-2";
export var imageContainer = "_im-0";
export var selectedCard = "_im-3";